<template>
  <div class="main" style="padding-top:0px">
    <parallax :overlay="false" :classes="'without-img'" style="background-color: #d4d4d4;margin-top: 0px">
      <template slot="content">
        <div>
            <span class="title-content">
                <text-lang :lang="lang">
                    <template slot="es">Inversión de Capital</template>
                    <template slot="en">Capital Investment</template>
                </text-lang>
            </span>
        </div>
      </template>
    </parallax>

    <section class="light-content">
        <div class="container">
            <p class="text text-primary">
                <text-lang :lang="lang">
                    <template slot="es">Como empresa emisora, captamos recursos a través de emisiones de títulos valores en mercados de valores, para inyectárselo a empresas con el objeto de abaratarles el costo financiero, liberarles finanzas y aumentarles el capital para crecer nacionalmente e internacionalmente</template>
                    <template slot="en">As a securities issuing company, we raise capital through the issuance of debt and equity securities  in the stock market to invest and finance companies; improving and enhancing their overall performance allowing them to grow</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Nos enfocamos principalmente en empresas en marcha de consumo masivo con alto potencial de crecimiento.</template>
                    <template slot="en">We invest primarily in operating companies producing tangible, mass-consumption goods or commodities, with a high potential for growth and development.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Somos el vehículo para capitalizar y mejorar el perfil de deuda de empresas a través de los mercados de valores.</template>
                    <template slot="en">We are the right solution to raise companies' capital levels and improve their debt profile through the stock market.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <text-lang :lang="lang">
                    <template slot="es">Invertir  >>>  Mejorar >>> Mercado de Valores Nacional</template>
                    <template slot="en">Invest  >>>  Maximize Performance >>> Public Offering</template>
                </text-lang>
            </p>
            <p class="title-content">
              <text-lang :lang="lang">
                <template slot="es">¿Qué financiamos?</template>
                <template slot="en">What do we finance?</template>
              </text-lang>
            </p>
            <p class="text text-secondary">
                <span>1.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Capitalizamos empresas que tengan mercados para crecer.</template>
                    <template slot="en">Invest capital in companies with expanding markets and industries.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>2.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Financiamos la compra de empresas, fusiones y adquisiciones.</template>
                    <template slot="en">Finance companies' mergers and acquisitions projects.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>3.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Hacemos líquidas las acciones de inversionistas en las empresas privadas del país.</template>
                    <template slot="en">We make liquid private companies' shareholders' equity through stock markets.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>4.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Protegemos el capital de los accionistas de las empresas privadas del país.</template>
                    <template slot="en">We protect domestic private companies' shareholders' capital.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>5.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Compramos empresas directamente.</template>
                    <template slot="en">Directly acquire companies.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>6.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Financiamos transiciones generacionales, adquisición de acciones por parte de empleados y/o entre accionistas.</template>
                    <template slot="en">We finance generational transitions, employees' or shareholders' stock purchases.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>7.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Reestructuramos empresas.</template>
                    <template slot="en">Restructuring and Refinancing.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>8.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Alquilamos empresas para una la mejor valoración luego de alcanzados los objetivos de inversión.</template>
                    <template slot="en">We rent companies to achieve a better valuation.</template>
                </text-lang>
            </p>
            <p class="text text-secondary">
                <span>9.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Capitalizamos empresas expropiadas que deseen junto a sus dueños reactivarse.</template>
                    <template slot="en">We invest capital in government expropriated companies' operations. </template>
                </text-lang>
            </p>
            <p class="text text-secondary" style="margin-bottom: 0px !important">
                <span>10.- </span>
                <text-lang :lang="lang">
                    <template slot="es">Reactivamos empresas del estado.</template>
                    <template slot="en">We reactivate State owned companies. </template>
                </text-lang>
            </p>
        </div> <!-- /.container -->
    </section> <!-- /.services -->
  </div>
</template>

<script>
// @ is an alias to /src
import Parallax from '@/components/Parallax.vue'
import TextLang from '@/components/TextLang.vue'

export default {
    name: 'CapitalInvestment',
    props: ['lang'],
    components: {
        Parallax,
        TextLang
    }
}
</script>
